document.addEventListener("DOMContentLoaded", function () {
  const emblaNode = document.querySelector(".video_gallery--embla .embla__viewport");
  const embla = EmblaCarousel(emblaNode, {
    loop: true,
    align: "start",
    draggable: true,
  });

  const prevBtn = document.querySelector(".embla__button--prev");
  const nextBtn = document.querySelector(".embla__button--next");

  if (embla && prevBtn && nextBtn) {
    prevBtn.addEventListener("click", () => embla.scrollPrev());
    nextBtn.addEventListener("click", () => embla.scrollNext());
  }
});


let swiperInstance;

function initSwiper() {
  if (window.innerWidth <= 1024 && swiperInstance) {
    swiperInstance.destroy(true, true);
    swiperInstance = undefined;
  }
}

// Init on load
initSwiper();

// Re-init on resize
window.addEventListener('resize', initSwiper);


document.querySelector('.btn-add-to-cart').addEventListener('click', async (e) => {
  const variantId = e.target.getAttribute('data-variant-id');
  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  });
  
  if (response.ok) {
    alert('Product added to cart!');
  } else {
    alert('Error adding to cart');
  }
});
